import { render, staticRenderFns } from "./QuoteFormSource.vue?vue&type=template&id=65595223&scoped=true&"
import script from "./QuoteFormSource.vue?vue&type=script&lang=ts&"
export * from "./QuoteFormSource.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteFormSource.vue?vue&type=style&index=0&id=65595223&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65595223",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
